import React, { useRef, useEffect } from 'react';
import '../../Styles/ReusableComponents/popupDefault.scss';

/**
 * A reusable popup background component that handles closing when clicking outside
 * 
 * @param {Object} props
 * @param {React.ReactNode} props.children - Content to display inside the popup (your custom popup component)
 * @param {Function} props.onClose - Function to call when popup should close
 * @param {Object} props.style - Optional additional styles for the background
 */
const PopupDefault = ({ children, onClose = {} }) => {
  const popupRef = useRef(null);
  const backgroundRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      // If clicking inside the popup content, don't close
      if (popupRef.current && popupRef.current.contains(event.target)) {
        return;
      }

      // Don't close if clicking on auth modal overlay
      if (event.target.closest('.auth-modal-overlay')) {
        return;
      }

      // Check if clicking on another popup's container (nested popup)
      const allPopupContainers = document.querySelectorAll('.popup-container');
      const clickedInAnotherPopup = Array.from(allPopupContainers).some(
        container => container !== popupRef.current && container.contains(event.target)
      );

      if (clickedInAnotherPopup) {
        return; // Don't close if clicking inside another popup
      }

      // If we're clicking on THIS popup's background, close it
      if (backgroundRef.current && backgroundRef.current.contains(event.target)) {
        event.stopPropagation();
        onClose();
      }
    };

    // Use capture phase to handle the event before it bubbles
    document.addEventListener('mousedown', handleClickOutside, true);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside, true);
    };
  }, [onClose]);

  return (
    <div className="popup-default" ref={backgroundRef}>
      <div
        ref={popupRef}
        className="popup-container"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
};

const CloseButton = ({ onClose = {} }) => {
  return (
    <button className="close-btn" onClick={onClose}>
      <svg width={30} height={30} xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.2} stroke="#211f1c">
        <path strokeLinecap="round" strokeLinejoin="round" d="m9.75 9.75 4.5 4.5m0-4.5-4.5 4.5M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0Z" />
      </svg>

    </button>
  );
};

export { PopupDefault, CloseButton };

























